export const ComponentStageMode = {
  Selected: 'Selected',
} as const;

export type StageMode = ValueOf<typeof ComponentStageMode>;
